import { defineStore } from 'pinia'

import { resourceApi } from './common/api'

export const useHome = defineStore('home', {
  state() {
    return {
      fetchHomeFrequency: 300000,
      activityIndicators: null,
      institutionsCounter: null,
      isLoadingActivityIndicators: false,
      errorActivityIndicators: null,
      statusActivityIndicators: null,
      fetchActivityIndicatorsInterval: null
    }
  },

  getters: {
    getActivityIndicators: ({ activityIndicators }) => {
      return activityIndicators
    },
    getErrors: ({ errorActivityIndicators }) => {
      let returnValue = []
      if (errorActivityIndicators)
        returnValue.push({
          text: errorActivityIndicators,
          key: 'activityIndicators'
        })
      return returnValue
    },
    getFetchHomeFrequency: ({ fetchHomeFrequency }) => {
      return fetchHomeFrequency
    },
    getFetchActivityIndicatorsInterval: ({ fetchActivityIndicatorsInterval }) => {
      return fetchActivityIndicatorsInterval
    },
    getIsLoadingActivityIndicators: ({ isLoadingActivityIndicators }) => {
      return isLoadingActivityIndicators
    },
  },

  actions: {
    async fetchActivityIndicators(withLoader = true) {
      if (!this.isLoadingActivityIndicators) {
        if (this.errorActivityIndicators != null)
          this.errorActivityIndicators = null
        this.statusActivityIndicators = null
        if (withLoader) this.isLoadingActivityIndicators = true
        try {
          const result = await resourceApi.get('activityIndicators')
          const { error, activityIndicators } = result.data.response
          this.statusActivityIndicators = result.data.status
          if (error) this.errorActivityIndicators = error.message
          else this.activityIndicators = activityIndicators
        } catch (e) {
          this.errorActivityIndicators =
            e?.response?.data?.response?.error?.message ||
            e.message ||
            String(e) ||
            JSON.stringify(e)
        }
        this.isLoadingActivityIndicators = false
      }
    },
    setFetchActivityIndicatorsInterval(newValue) {
      if (newValue == null && this.fetchActivityIndicatorsInterval != null)
        clearInterval(this.fetchActivityIndicatorsInterval)
      this.fetchActivityIndicatorsInterval = newValue
    },
    cancelError(key) {
      switch (key) {
      case 'activityIndicators':
        this.errorActivityIndicators = null
        break
      default:
        this.errorActivityIndicators = null
      }
    },
    resetState() {
      this.activityIndicators = null
    }
  }
})
